import { useReactTable, getCoreRowModel, createColumnHelper } from '@tanstack/react-table';
import { ExerciseLog } from '../../Clients/reminds';
import Table from '../../Components/Table/Table';
import { useExerciseLogsContext } from '../../Contexts/ExerciseLogs.Context';
import { Remove } from '../../Icons/Remove';

const columnHelper = createColumnHelper<ExerciseLog>();

const defaultColumns = [
  columnHelper.accessor('exerciseType.name', {
    header: 'Exercise',
  }),
  columnHelper.accessor('numberOfReps', {
    header: 'Reps',
  }),
  columnHelper.accessor('numberOfSets', {
    header: 'Sets',
  }),
  columnHelper.accessor('comment', {
    header: 'Comment',
  }),
  columnHelper.accessor('user.name', {
    header: 'User',
  }),
  columnHelper.display({
    id: 'actions',
    header: 'Actions',
    cell: props => {
      return <DeleteButton id={props.row.original.id} />;
    },
  }),
];

export const ExerciseLogsTable = () => {
  const { data } = useExerciseLogsContext();

  const table = useReactTable({
    data,
    columns: defaultColumns,
    getCoreRowModel: getCoreRowModel(),
  });

  return <Table table={table}></Table>;
};

const DeleteButton: React.FC<{ id: number | undefined }> = ({ id }) => {
  const { deleteExerciseLog } = useExerciseLogsContext();

  const handleDelete = () => {
    if (id) deleteExerciseLog(id);
  };

  return <Remove onRemove={handleDelete} />;
};
